import Vue from 'vue';
import $web3js from './web3.js';
import $erc20 from './erc20/index.js';
import $erc721 from './erc721/index.js';
import $bscDmexJointMining from './bscDmexJointMining/index.js';
import $bscDmcMining from './bscDmcMining/index.js';

//
import $dmcMining from './dmcMining/index.js';
// import $ifilAbs from './ifilAbs/index.js';
import $ifilJointU from './ifilJointU/index.js';
import $ifilMining from './ifilMining/index.js';
import $ifilMiningV2 from './ifilMiningV2/index.js';
import $ifilMiningV3 from './ifilMiningV3/index.js';
import $ifilMiningV4 from './ifilMiningV4/index.js';
import $ifilMiningV5 from './ifilMiningV5/index.js';
import $ifilNftTrade from './ifilNftTrade/index.js';
import $ifilNftTradeV2 from './ifilNftTradeV2/index.js';
import $ifilVendor from './ifilVendor/index.js';
import $ifilVendorV2 from './ifilVendorV2/index.js';
import $ifilVendorV3 from './ifilVendorV3/index.js';
import $ifilVendorV4 from './ifilVendorV4/index.js';
import $ifilVendorV5 from './ifilVendorV5/index.js';
import $peTimeLock from './peTimeLock/index.js';
import $swapMining from './swapMining/index.js';
import $IMdexPair from './IMdexPair/index.js';
import $dmcPool from './dmcPool/index.js';
import $vipPool from './vipPool/index.js';
import $pledgePool from './pledgePool/index.js';
import $tokenSwap from './tokenSwap/index.js';
import $power from './power.js';
import $dmexAggregator from './dmexAggregator/index.js';
import $rewardPool from './rewardPool/index.js';
import $dmexLend from './dmexLend/index.js';
import $multiCall from './multiCall/index.js';
import $currentLocker from './currentLocker/index.js';
import $fixedLocker from './fixedLocker/index.js';
import $fPoolProposal from './fPoolProposal/index.js';
import $multiSig from './multiSig/index.js';
import $governanceVote from './governanceVote/index.js';
import $CommitteeElect from './CommitteeElect/index.js';
import $ifilSwap from './ifilSwap/index.js';
import $lockMining from './lockMining/index.js';
import $usdtLockMining from './usdtLockMining/index.js';
import $dmcLocker from './dmcLocker/index.js';
import $nftMigrate from './nftMigrate/index.js';
import $pledgeRedeem from './redeem/index.js';


let defaultInviteCode = "DMEX";

const getDefaultInviteCode = () => {
    return defaultInviteCode;
}

const getInviterCode = () => {
    let $key = 'inviter_code';
    return Vue.prototype.$storage.get($key);
}

const setInviterCode = (inviteCode) => {
    let $key = 'inviter_code';
    return Vue.prototype.$storage.set($key, inviteCode);
}

const checkNotSupportWeb3jsV1 = (error) => {
    return String(error).startsWith(
            "Error: The current provider doesn't support subscriptions:"
        ) ||
        String(error).startsWith(
            "Error: eth_subscribe is not supported"
        )
}

// const multiCall = async () => {
//     let calls = [];
//     let handles = [];
//     let handlerParams = [];

//     let call1 = [$erc20.getErc20Address('HFIL'), $web3js.encodeFunctionCall($erc20.getErc20Abi('decimals'), [])];
//     calls.push(call1);
//     handles.push($web3js.decodeParameterReverse);
//     handlerParams.push(['uint8']);

//     let call2 = [$erc20.getErc20Address('DMC'), $web3js.encodeFunctionCall($erc20.getErc20Abi('decimals'), [])];
//     calls.push(call2);
//     handles.push($web3js.decodeParameterReverse);
//     handlerParams.push(['uint8']);

//     let call3 = [$erc20.getErc20Address('HUSD'), $web3js.encodeFunctionCall($erc20.getErc20Abi('decimals'), [])];
//     calls.push(call3);
//     handles.push($web3js.decodeParameterReverse);
//     handlerParams.push(['uint8']);

//     let call4 = $erc20.getErc20BalanceCall([$erc20.getErc20Address('HUSD'), '0xe419238c8a12A694151e31B6399dF89EA687D062']);
//     calls.push(call4);
//     handles.push($erc20.fromErc20Value);
//     handlerParams.push([$erc20.getErc20Address('HUSD')]);

//     let call5 = $erc20.getErc20BalanceCall([$erc20.getErc20Address('HFIL'), '0xe419238c8a12A694151e31B6399dF89EA687D062']);
//     calls.push(call5);
//     handles.push($web3js.fromWei);
//     handlerParams.push([]);

//     let results = await $multiCall.multiCall([calls, handles, handlerParams]);

//     console.log('multiCall results :>> ', results);

//     return results;
// }

// console.log('multiCall :>> ', multiCall());

export default {
    ...$web3js,
    ...$erc20,
    ...$erc721,
    ...$dmcMining,
    ...$bscDmexJointMining,
    ...$bscDmcMining,
    //
    // ...$ifilAbs,
    ...$ifilJointU,
    ...$ifilMining,
    ...$ifilMiningV2,
    ...$ifilMiningV3,
    ...$ifilMiningV4,
    ...$ifilMiningV5,
    ...$ifilNftTrade,
    ...$ifilNftTradeV2,
    ...$ifilVendor,
    ...$ifilVendorV2,
    ...$ifilVendorV3,
    ...$ifilVendorV4,
    ...$ifilVendorV5,
    ...$peTimeLock,
    ...$swapMining,
    ...$IMdexPair,
    ...$dmcPool,
    ...$vipPool,
    ...$power,
    ...$tokenSwap,
    ...$pledgePool,
    ...$dmexAggregator,
    ...$rewardPool,
    ...$dmexLend,
    ...$multiCall,
    ...$currentLocker,
    ...$fixedLocker,
    ...$fPoolProposal,
    ...$multiSig,
    ...$governanceVote,
    ...$CommitteeElect,
    ...$ifilSwap,
    ...$lockMining,
    ...$usdtLockMining,
    ...$dmcLocker,
    ...$nftMigrate,
    ...$pledgeRedeem,
    // other setting
    getDefaultInviteCode,
    getInviterCode,
    setInviterCode,
    checkNotSupportWeb3jsV1,
}



// WEBPACK FOOTER //
// ./src/lib/contract/index.js